import { ApiRegistrationParticipantForParticipantResponse } from "shared/types/ApiRegistrationParticipantForParticipantResponse";
import { RegFormApiResponseType } from "../../../../types/regFormApiResponse";
import { RegistrationStep } from "../../../../../../shared/utils/enums";

export interface EmailValidationWrapperPropsType {
  regFormDetailObj?: RegFormApiResponseType;
  participantObj?: ApiRegistrationParticipantForParticipantResponse;
  setCurrentStep: (step: RegistrationStep) => void;
}

export const EMAIL_FIELD_NAME = "workEmail";
